<template>
    <div class="home-header">
        <div class="content">
            <public-logo />
            <public-nav v-on="$listeners" />
        </div>
    </div>
</template>

<script>
import PublicLogo from "./Logo";
import PublicNav from "./Nav";
export default {
    name: "PublicHeader",
    components: {
        PublicLogo,
        PublicNav
    },
};
</script>

<style lang="scss" scoped>
.home-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 88px;
    background: rgba(255, 255, 255, 0.8);
    z-index: 99;
}

</style>